import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Adjustment = {
  amount?: Maybe<Scalars['Float']['output']>;
  franchise: Franchise;
  history?: Maybe<Array<Transaction>>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Player>;
  season?: Maybe<Season>;
};

export type AdjustmentAsset = {
  adjustment?: Maybe<Adjustment>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  player?: Maybe<Player>;
  previousDesignation?: Maybe<Scalars['String']['output']>;
  previousFranchise?: Maybe<Scalars['String']['output']>;
  previousSalary?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Season>;
  to?: Maybe<Franchise>;
  type: Scalars['String']['output'];
};

/** Autogenerated input type of ApproveTransaction */
export type ApproveTransactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveTransaction */
export type ApproveTransactionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when approving the transaction. */
  errors: Array<Scalars['String']['output']>;
  /** The approved Transaction. */
  transaction?: Maybe<Transaction>;
};

export type Auction = {
  /** All closed auction items for this auction */
  completedItems: Array<AuctionItem>;
  /** The auction item associated with this auction */
  currentAuctionItem?: Maybe<AuctionItem>;
  id: Scalars['ID']['output'];
  /** The mode of the auction (manual or auto) */
  mode: AuctionMode;
  /** The current status of the auction */
  status: AuctionStatus;
};

export type AuctionItem = {
  /** All bids placed on this item, most recent first */
  bids: Array<Bid>;
  currentBid: Scalars['Int']['output'];
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  leadingFranchise?: Maybe<Franchise>;
  player?: Maybe<Player>;
  /** The current status of the auction item */
  status: AuctionItemStatus;
};

export enum AuctionItemStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  PAUSED = 'PAUSED'
}

export enum AuctionMode {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL'
}

export enum AuctionStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  PAUSED = 'PAUSED'
}

export type Bid = {
  amount: Scalars['Int']['output'];
  auctionItem: AuctionItem;
  createdAt: Scalars['ISO8601DateTime']['output'];
  franchise: Franchise;
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of CancelAuctionItem */
export type CancelAuctionItemInput = {
  auctionItemId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelAuctionItem */
export type CancelAuctionItemPayload = {
  /** The canceled auction item. */
  auctionItem?: Maybe<AuctionItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred while canceling. */
  errors: Array<Scalars['String']['output']>;
};

/** A cap space transaction between two franchises */
export type CapSpace = {
  amount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  owner: Franchise;
  recipient: Franchise;
  season: Season;
};

/** A cap space transaction between two franchises */
export type CapSpaceAsset = {
  from?: Maybe<Franchise>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Season>;
  to?: Maybe<Franchise>;
};

/** Autogenerated input type of ChangeSeason */
export type ChangeSeasonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The year to make current */
  year: Scalars['Int']['input'];
};

/** Autogenerated return type of ChangeSeason */
export type ChangeSeasonPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occurred when creating the season. */
  errors: Array<Scalars['String']['output']>;
  /** The created Season. */
  season?: Maybe<Season>;
};

export type Contract = {
  designation?: Maybe<Designation>;
  franchise?: Maybe<Franchise>;
  id: Scalars['ID']['output'];
  league: League;
  player: Player;
  salary?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of CreateBid */
export type CreateBidInput = {
  amount: Scalars['Int']['input'];
  auctionItemId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateBid */
export type CreateBidPayload = {
  /** The auction item that was bid on. */
  auctionItem?: Maybe<AuctionItem>;
  /** The accepted bid (if any). */
  bid?: Maybe<Bid>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occurred while placing the bid. */
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDraft */
export type CreateDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The year of the season. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateDraft */
export type CreateDraftPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occurred when creating the season. */
  errors: Array<Scalars['String']['output']>;
  /** The season for which the draft is being created. */
  season?: Maybe<Season>;
};

/** Autogenerated input type of CreateSeason */
export type CreateSeasonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The year of the season. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateSeason */
export type CreateSeasonPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occurred when creating the season. */
  errors: Array<Scalars['String']['output']>;
  /** The created Season. */
  season?: Maybe<Season>;
};

/** Autogenerated input type of CreateTransactionAsset */
export type CreateTransactionAssetInput = {
  asset: TransactionAssetInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTransactionAsset */
export type CreateTransactionAssetPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when saving the transaction. */
  errors: Array<Scalars['String']['output']>;
  /** The saved Transaction. */
  transaction?: Maybe<Transaction>;
  /** The type of transaction. */
  type: TransactionKind;
};

/** Autogenerated input type of CreateTransaction */
export type CreateTransactionInput = {
  approve?: InputMaybe<Scalars['Boolean']['input']>;
  assets: Array<TransactionAssetInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type: TransactionKind;
};

/** Autogenerated return type of CreateTransaction */
export type CreateTransactionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when saving the transaction. */
  errors: Array<Scalars['String']['output']>;
  /** The saved Transaction. */
  transaction?: Maybe<Transaction>;
  /** The type of transaction. */
  type: TransactionKind;
};

export type Data = {
  chart: Scalars['String']['output'];
  colors: Scalars['JSON']['output'];
  data: Scalars['JSON']['output'];
  keys: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeactivateAdjustment */
export type DeactivateAdjustmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeactivateAdjustment */
export type DeactivateAdjustmentPayload = {
  /** The deactivated Adjustment. */
  adjustment?: Maybe<Adjustment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when deactivatin the adjustment. */
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeclineTransaction */
export type DeclineTransactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineTransaction */
export type DeclineTransactionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when declining the transaction. */
  errors: Array<Scalars['String']['output']>;
  /** The declined Transaction. */
  transaction?: Maybe<Transaction>;
};

/** Autogenerated input type of DeleteTransactionAsset */
export type DeleteTransactionAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  transactionAssetId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTransactionAsset */
export type DeleteTransactionAssetPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when saving the transaction. */
  errors: Array<Scalars['String']['output']>;
  /** The saved Transaction. */
  transaction?: Maybe<Transaction>;
  /** The type of transaction. */
  type: TransactionKind;
};

export type Designation = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
};

export type DraftPick = {
  designation?: Maybe<Designation>;
  franchise?: Maybe<Franchise>;
  history?: Maybe<Array<Transaction>>;
  id: Scalars['ID']['output'];
  originalFranchise?: Maybe<Franchise>;
  pick?: Maybe<Scalars['Int']['output']>;
  player?: Maybe<Player>;
  round: Scalars['Int']['output'];
  salary?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Season>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
};

export type DraftPickAsset = {
  designationId?: Maybe<Scalars['Int']['output']>;
  draftPick: DraftPick;
  draftedPlayer?: Maybe<Player>;
  from?: Maybe<Franchise>;
  id: Scalars['ID']['output'];
  season?: Maybe<Season>;
  to?: Maybe<Franchise>;
  type: Scalars['String']['output'];
};

/** Autogenerated input type of FavoritePlayer */
export type FavoritePlayerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of FavoritePlayer */
export type FavoritePlayerPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when favoriting the player. */
  errors: Array<Scalars['String']['output']>;
  /** The favorited player. */
  player?: Maybe<Player>;
};

export type Franchise = {
  abbr?: Maybe<Scalars['String']['output']>;
  adjustments: Array<Adjustment>;
  availableCapSpace: Scalars['Float']['output'];
  availableDraftPicks: Array<DraftPick>;
  availableRosterSpots: Scalars['Float']['output'];
  capSpacesGiven: Array<CapSpace>;
  capSpacesReceived: Array<CapSpace>;
  color?: Maybe<Scalars['String']['output']>;
  contracts: Array<Contract>;
  draftPicks: Array<DraftPick>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  motto?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  owner?: Maybe<User>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type League = {
  capSpace?: Maybe<Scalars['Int']['output']>;
  commissioner: User;
  draftPicks?: Maybe<Array<DraftPick>>;
  franchises?: Maybe<Array<Franchise>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rosterLimit?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Season>;
};

/** Autogenerated input type of Login */
export type LoginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Autogenerated return type of Login */
export type LoginPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  /** Approve a transaction */
  approveTransaction?: Maybe<ApproveTransactionPayload>;
  /** Cancel an active auction item for the active league auction */
  cancelAuctionItem?: Maybe<CancelAuctionItemPayload>;
  /** Change the current season for the current league */
  changeSeason?: Maybe<ChangeSeasonPayload>;
  /** Place a bid on an active auction item */
  createBid?: Maybe<CreateBidPayload>;
  /** Create a new draft */
  createDraft?: Maybe<CreateDraftPayload>;
  /** Create a new season */
  createSeason?: Maybe<CreateSeasonPayload>;
  /** Create a transaction */
  createTransaction?: Maybe<CreateTransactionPayload>;
  /** Create a transaction asset */
  createTransactionAsset?: Maybe<CreateTransactionAssetPayload>;
  /** Deactivate an adjustment */
  deactivateAdjustment?: Maybe<DeactivateAdjustmentPayload>;
  /** Decline a transaction */
  declineTransaction?: Maybe<DeclineTransactionPayload>;
  /** Delete a transaction asset */
  deleteTransactionAsset?: Maybe<DeleteTransactionAssetPayload>;
  /** Favorite a player */
  favoritePlayer?: Maybe<FavoritePlayerPayload>;
  login?: Maybe<LoginPayload>;
  /** Nominate a player to start a new auction item for the active league auction */
  nominatePlayer?: Maybe<NominatePlayerPayload>;
  /** Pause the countdown for an auction item */
  pauseCountdown?: Maybe<PauseCountdownPayload>;
  /** Save a franchise */
  saveFranchise?: Maybe<SaveFranchisePayload>;
  sendAuctionReaction?: Maybe<SendAuctionReactionPayload>;
  /** Skip a draft pick */
  skipDraftPick?: Maybe<SkipDraftPickPayload>;
  /** Start the countdown for an auction item */
  startCountdown?: Maybe<StartCountdownPayload>;
  /** Update a transaction's status */
  updateTransactionStatus?: Maybe<UpdateTransactionStatusPayload>;
};


export type MutationapproveTransactionArgs = {
  input: ApproveTransactionInput;
};


export type MutationcancelAuctionItemArgs = {
  input: CancelAuctionItemInput;
};


export type MutationchangeSeasonArgs = {
  input: ChangeSeasonInput;
};


export type MutationcreateBidArgs = {
  input: CreateBidInput;
};


export type MutationcreateDraftArgs = {
  input: CreateDraftInput;
};


export type MutationcreateSeasonArgs = {
  input: CreateSeasonInput;
};


export type MutationcreateTransactionArgs = {
  input: CreateTransactionInput;
};


export type MutationcreateTransactionAssetArgs = {
  input: CreateTransactionAssetInput;
};


export type MutationdeactivateAdjustmentArgs = {
  input: DeactivateAdjustmentInput;
};


export type MutationdeclineTransactionArgs = {
  input: DeclineTransactionInput;
};


export type MutationdeleteTransactionAssetArgs = {
  input: DeleteTransactionAssetInput;
};


export type MutationfavoritePlayerArgs = {
  input: FavoritePlayerInput;
};


export type MutationloginArgs = {
  input: LoginInput;
};


export type MutationnominatePlayerArgs = {
  input: NominatePlayerInput;
};


export type MutationpauseCountdownArgs = {
  input: PauseCountdownInput;
};


export type MutationsaveFranchiseArgs = {
  input: SaveFranchiseInput;
};


export type MutationsendAuctionReactionArgs = {
  input: SendAuctionReactionInput;
};


export type MutationskipDraftPickArgs = {
  input: SkipDraftPickInput;
};


export type MutationstartCountdownArgs = {
  input: StartCountdownInput;
};


export type MutationupdateTransactionStatusArgs = {
  input: UpdateTransactionStatusInput;
};

/** Autogenerated input type of NominatePlayer */
export type NominatePlayerInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
};

/** Autogenerated return type of NominatePlayer */
export type NominatePlayerPayload = {
  /** The new active auction item. */
  auctionItem?: Maybe<AuctionItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred while nominating. */
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of PauseCountdown */
export type PauseCountdownInput = {
  auctionItemId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PauseCountdown */
export type PauseCountdownPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occurred while pausing the countdown. */
  errors: Array<Scalars['String']['output']>;
  /** Indicates if the countdown was successfully paused. */
  success: Scalars['Boolean']['output'];
};

export type Player = {
  adp?: Maybe<Scalars['Int']['output']>;
  contract?: Maybe<Contract>;
  contracts?: Maybe<Array<Contract>>;
  history?: Maybe<Array<Transaction>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['String']['output'];
  team?: Maybe<Scalars['String']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type PlayerAsset = {
  contract?: Maybe<Contract>;
  designation?: Maybe<Designation>;
  from?: Maybe<Franchise>;
  id: Scalars['ID']['output'];
  player: Player;
  previousDesignation?: Maybe<Scalars['String']['output']>;
  previousFranchise?: Maybe<Scalars['String']['output']>;
  previousSalary?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  season?: Maybe<Season>;
  to?: Maybe<Franchise>;
  type: Scalars['String']['output'];
};

export type PlayerCollection = {
  players: Array<Player>;
  total: Scalars['Int']['output'];
};

/** The query root of this schema */
export type Query = {
  /** Find an adjustment by id */
  adjustment: Adjustment;
  /** Search for players */
  allPlayers: PlayerCollection;
  /** Search for transactions */
  allTransactions: TransactionCollection;
  /** Find current auction for league */
  auction?: Maybe<Auction>;
  /** Return data for a specific chart/report */
  data: Data;
  /** Final all designations */
  designations: Array<Designation>;
  /** Franchises with bulk-precomputed cap space for the draft hub */
  draftHubFranchises: Array<Franchise>;
  /** Find a draft pick by id */
  draftPick: DraftPick;
  /** Find all draft picks */
  draftPicks: Array<DraftPick>;
  favorites: Array<Player>;
  /** Find a franchise by id */
  franchise?: Maybe<Franchise>;
  /** Find all franchises */
  franchises: Array<Franchise>;
  /** Find an offseason negotiation by franchise id and season */
  offseasonNegotiation: Transaction;
  /** Find all offseason negotiations for a season */
  offseasonNegotiations: Array<Transaction>;
  /** Find a player by id */
  player: Player;
  /** Returns all seasons in the league */
  seasons: Array<Season>;
  /** Find a transaction by id */
  transaction: Transaction;
  /** Find all transactions */
  transactions: Array<Transaction>;
  /** Find all years */
  years: Array<Scalars['Int']['output']>;
};


/** The query root of this schema */
export type QueryadjustmentArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryallPlayersArgs = {
  contract?: InputMaybe<Scalars['String']['input']>;
  favorites?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  rookies?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of this schema */
export type QueryallTransactionsArgs = {
  franchiseId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionKind>;
};


/** The query root of this schema */
export type QuerydataArgs = {
  chart: Scalars['String']['input'];
};


/** The query root of this schema */
export type QuerydraftPickArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QuerydraftPicksArgs = {
  franchiseId?: InputMaybe<Scalars['ID']['input']>;
  onlyAvailable: Scalars['Boolean']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root of this schema */
export type QueryfranchiseArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QueryoffseasonNegotiationArgs = {
  franchiseId: Scalars['ID']['input'];
  season: Scalars['Int']['input'];
};


/** The query root of this schema */
export type QueryoffseasonNegotiationsArgs = {
  season: Scalars['Int']['input'];
};


/** The query root of this schema */
export type QueryplayerArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of this schema */
export type QuerytransactionArgs = {
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of SaveFranchise */
export type SaveFranchiseInput = {
  abbr?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['Upload']['input']>;
  motto?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveFranchise */
export type SaveFranchisePayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when saving the franchise. */
  errors: Array<Scalars['String']['output']>;
  /** The saved franchise. */
  franchise?: Maybe<Franchise>;
};

export type Season = {
  current: Scalars['Boolean']['output'];
  /** Indicates if the season has a draft. */
  hasDraft: Scalars['Boolean']['output'];
  /** Indicates if the season has negotiations. */
  hasNegotiations: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

/** Autogenerated input type of SendAuctionReaction */
export type SendAuctionReactionInput = {
  auctionId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emoji: Scalars['String']['input'];
};

/** Autogenerated return type of SendAuctionReaction */
export type SendAuctionReactionPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SkipDraftPick */
export type SkipDraftPickInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of SkipDraftPick */
export type SkipDraftPickPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The skipped Draft Pick. */
  draftPick?: Maybe<DraftPick>;
  /** A list of errors that occured when skipping the draft pick. */
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of StartCountdown */
export type StartCountdownInput = {
  auctionItemId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StartCountdown */
export type StartCountdownPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occurred while starting the countdown. */
  errors: Array<Scalars['String']['output']>;
  /** Indicates if the countdown was successfully started. */
  success: Scalars['Boolean']['output'];
};

export type Transaction = {
  assets?: Maybe<Array<TransactionAsset>>;
  date: Scalars['String']['output'];
  franchise?: Maybe<Franchise>;
  id: Scalars['ID']['output'];
  league: League;
  note?: Maybe<Scalars['String']['output']>;
  rejectionMessages: Array<Scalars['String']['output']>;
  season?: Maybe<Season>;
  status: TransactionStatus;
  type: TransactionKind;
};

export type TransactionAsset = AdjustmentAsset | CapSpaceAsset | DraftPickAsset | PlayerAsset;

export type TransactionAssetInput = {
  adjustmentId?: InputMaybe<Scalars['Int']['input']>;
  contractId?: InputMaybe<Scalars['Int']['input']>;
  designation?: InputMaybe<Scalars['Int']['input']>;
  draftPickId?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['Int']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  seasonId?: InputMaybe<Scalars['Int']['input']>;
  tempId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
  type: TransactionAssetKind;
};

export enum TransactionAssetKind {
  AdjustmentAsset = 'AdjustmentAsset',
  CapSpaceAsset = 'CapSpaceAsset',
  DraftPickAsset = 'DraftPickAsset',
  PlayerAsset = 'PlayerAsset'
}

export type TransactionCollection = {
  total: Scalars['Int']['output'];
  transactions: Array<Transaction>;
};

export enum TransactionKind {
  DraftPickTransaction = 'DraftPickTransaction',
  Negotiation = 'Negotiation',
  OffseasonNegotiation = 'OffseasonNegotiation',
  Trade = 'Trade',
  Waiver = 'Waiver'
}

export enum TransactionStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  DRAFT = 'DRAFT',
  PENDING = 'PENDING'
}

/** Autogenerated input type of UpdateTransactionStatus */
export type UpdateTransactionStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: TransactionStatus;
};

/** Autogenerated return type of UpdateTransactionStatus */
export type UpdateTransactionStatusPayload = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A list of errors that occured when updating the transaction. */
  errors: Array<Scalars['String']['output']>;
  /** The updated Transaction. */
  transaction?: Maybe<Transaction>;
};

export type User = {
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SeasonsFieldsFragment = { id: string, year: number };

export type SeasonsWithMetaFieldsFragment = { id: string, year: number, current: boolean, hasDraft: boolean, hasNegotiations: boolean };

export type AdjustmentFieldsFragment = { __typename: 'Adjustment', id: string, amount?: number | null, note?: string | null, season?: { id: string, year: number } | null, player?: { id: string, name: string } | null };

export type DesignationFieldsFragment = { id: string, name: string, order?: number | null };

export type FranchiseFieldsFragment = { id: string, name: string, logo?: string | null, abbr?: string | null };

export type CapSpaceFieldsFragment = { __typename: 'CapSpace', id: string, amount: number, note?: string | null, recipient: { id: string, name: string, logo?: string | null, abbr?: string | null }, owner: { id: string, name: string, logo?: string | null, abbr?: string | null }, season: { id: string, year: number } };

export type ContractPlayerFieldsFragment = { id: string, name: string, position: string, team?: string | null, adp?: number | null };

export type ContractFieldsFragment = { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } };

export type PlayerFieldsFragment = { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null };

export type DraftPickFieldsFragment = { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null };

export type PlayerAssetFieldsFragment = { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } };

export type CapSpaceAssetFieldsFragment = { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null };

export type AdjustmentAssetFieldsFragment = { __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null };

export type DraftPickAssetFieldsFragment = { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null };

export type FullTransactionFieldsFragment = { id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null };

export type FranchiseExpandedFieldsFragment = { phone?: string | null, order?: number | null, motto?: string | null, color?: string | null, availableCapSpace: number, availableRosterSpots: number, id: string, name: string, logo?: string | null, abbr?: string | null, owner?: { id: string, name?: string | null, email: string } | null, contracts: Array<{ id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } }>, adjustments: Array<{ __typename: 'Adjustment', id: string, amount?: number | null, note?: string | null, season?: { id: string, year: number } | null, player?: { id: string, name: string } | null }>, availableDraftPicks: Array<{ id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }>, capSpacesGiven: Array<{ __typename: 'CapSpace', id: string, amount: number, note?: string | null, recipient: { id: string, name: string, logo?: string | null, abbr?: string | null }, owner: { id: string, name: string, logo?: string | null, abbr?: string | null }, season: { id: string, year: number } }>, capSpacesReceived: Array<{ __typename: 'CapSpace', id: string, amount: number, note?: string | null, recipient: { id: string, name: string, logo?: string | null, abbr?: string | null }, owner: { id: string, name: string, logo?: string | null, abbr?: string | null }, season: { id: string, year: number } }> };

export type AuctionItemFieldsFragment = { id: string, status: AuctionItemStatus, currentBid: number, endsAt?: any | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null, leadingFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, bids: Array<{ id: string, amount: number, createdAt: any, franchise: { id: string, name: string, logo?: string | null } }> };

export type AuctionFieldsFragment = { id: string, status: AuctionStatus, mode: AuctionMode, currentAuctionItem?: { id: string, status: AuctionItemStatus, currentBid: number, endsAt?: any | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null, leadingFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, bids: Array<{ id: string, amount: number, createdAt: any, franchise: { id: string, name: string, logo?: string | null } }> } | null };

export type TransactionSearchQueryVariables = Exact<{
  type?: InputMaybe<TransactionKind>;
  franchiseId?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransactionSearchQuery = { allTransactions: { total: number, transactions: Array<{ id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null }> } };

export type DataQueryVariables = Exact<{
  chart: Scalars['String']['input'];
}>;


export type DataQuery = { data: { chart: string, data: any, colors: any, keys: Array<string> } };

export type PlayerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PlayerQuery = { player: { __typename: 'Player', id: string, name: string, position: string, team?: string | null, years?: number | null, history?: Array<{ id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null }> | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } };

export type AdjustmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AdjustmentQuery = { adjustment: { __typename: 'Adjustment', id: string, amount?: number | null, note?: string | null, history?: Array<{ id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null }> | null } };

export type DraftPickQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DraftPickQuery = { draftPick: { __typename: 'DraftPick', id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, history?: Array<{ id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null }> | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } };

export type TransactionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TransactionQuery = { transaction: { id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, season?: { year: number } | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null } };

export type OffseasonNegotiationQueryVariables = Exact<{
  franchiseId: Scalars['ID']['input'];
  season: Scalars['Int']['input'];
}>;


export type OffseasonNegotiationQuery = { offseasonNegotiation: { id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null } };

export type OffseasonNegotiationsQueryVariables = Exact<{
  season: Scalars['Int']['input'];
}>;


export type OffseasonNegotiationsQuery = { offseasonNegotiations: Array<{ id: string, type: TransactionKind, date: string, status: TransactionStatus, note?: string | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null }> };

export type FavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritesQuery = { favorites: Array<{ id: string }> };

export type FavoritesPlayersQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritesPlayersQuery = { favorites: Array<{ id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null }> };

export type AllPlayersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  favorites?: InputMaybe<Scalars['Boolean']['input']>;
  rookies?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllPlayersQuery = { allPlayers: { total: number, players: Array<{ id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null }> } };

export type FranchisesQueryVariables = Exact<{ [key: string]: never; }>;


export type FranchisesQuery = { franchises: Array<{ phone?: string | null, order?: number | null, motto?: string | null, color?: string | null, availableCapSpace: number, availableRosterSpots: number, id: string, name: string, logo?: string | null, abbr?: string | null, owner?: { id: string, name?: string | null, email: string } | null, contracts: Array<{ id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } }>, adjustments: Array<{ __typename: 'Adjustment', id: string, amount?: number | null, note?: string | null, season?: { id: string, year: number } | null, player?: { id: string, name: string } | null }>, availableDraftPicks: Array<{ id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }>, capSpacesGiven: Array<{ __typename: 'CapSpace', id: string, amount: number, note?: string | null, recipient: { id: string, name: string, logo?: string | null, abbr?: string | null }, owner: { id: string, name: string, logo?: string | null, abbr?: string | null }, season: { id: string, year: number } }>, capSpacesReceived: Array<{ __typename: 'CapSpace', id: string, amount: number, note?: string | null, recipient: { id: string, name: string, logo?: string | null, abbr?: string | null }, owner: { id: string, name: string, logo?: string | null, abbr?: string | null }, season: { id: string, year: number } }> }> };

export type DesignationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DesignationsQuery = { designations: Array<{ id: string, name: string, order?: number | null }> };

export type YearsQueryVariables = Exact<{ [key: string]: never; }>;


export type YearsQuery = { years: Array<number> };

export type SeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type SeasonsQuery = { seasons: Array<{ id: string, year: number, current: boolean, hasDraft: boolean, hasNegotiations: boolean }> };

export type DraftPicksQueryVariables = Exact<{
  onlyAvailable: Scalars['Boolean']['input'];
  franchiseId?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DraftPicksQuery = { draftPicks: Array<{ id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }> };

export type FranchiseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FranchiseQuery = { franchise?: { phone?: string | null, order?: number | null, motto?: string | null, color?: string | null, availableCapSpace: number, availableRosterSpots: number, id: string, name: string, logo?: string | null, abbr?: string | null, owner?: { id: string, name?: string | null, email: string } | null, contracts: Array<{ id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } }>, adjustments: Array<{ __typename: 'Adjustment', id: string, amount?: number | null, note?: string | null, season?: { id: string, year: number } | null, player?: { id: string, name: string } | null }>, availableDraftPicks: Array<{ id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }>, capSpacesGiven: Array<{ __typename: 'CapSpace', id: string, amount: number, note?: string | null, recipient: { id: string, name: string, logo?: string | null, abbr?: string | null }, owner: { id: string, name: string, logo?: string | null, abbr?: string | null }, season: { id: string, year: number } }>, capSpacesReceived: Array<{ __typename: 'CapSpace', id: string, amount: number, note?: string | null, recipient: { id: string, name: string, logo?: string | null, abbr?: string | null }, owner: { id: string, name: string, logo?: string | null, abbr?: string | null }, season: { id: string, year: number } }> } | null };

export type FranchiseStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FranchiseStatusQuery = { franchise?: { id: string, logo?: string | null, availableCapSpace: number, availableRosterSpots: number } | null };

export type AuctionQueryVariables = Exact<{ [key: string]: never; }>;


export type AuctionQuery = { auction?: { id: string, status: AuctionStatus, mode: AuctionMode, currentAuctionItem?: { id: string, status: AuctionItemStatus, currentBid: number, endsAt?: any | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null, leadingFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, bids: Array<{ id: string, amount: number, createdAt: any, franchise: { id: string, name: string, logo?: string | null } }> } | null } | null };

export type DraftHubFranchisesQueryVariables = Exact<{ [key: string]: never; }>;


export type DraftHubFranchisesQuery = { draftHubFranchises: Array<{ id: string, name: string, abbr?: string | null, logo?: string | null, color?: string | null, availableCapSpace: number, availableRosterSpots: number, contracts: Array<{ id: string, salary?: number | null, designation?: { id: string, name: string } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } }> }> };

export type DraftHubAuctionQueryVariables = Exact<{ [key: string]: never; }>;


export type DraftHubAuctionQuery = { auction?: { id: string, completedItems: Array<{ player?: { id: string } | null, leadingFranchise?: { id: string } | null }> } | null };

export type LoginUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginUserMutation = { login?: { token?: string | null, errors: Array<string> } | null };

export type CreateTransactionMutationVariables = Exact<{
  input: CreateTransactionInput;
}>;


export type CreateTransactionMutation = { createTransaction?: { errors: Array<string>, transaction?: { id: string } | null } | null };

export type ApproveTransactionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApproveTransactionMutation = { approveTransaction?: { errors: Array<string>, transaction?: { id: string, type: TransactionKind, season?: { year: number } | null } | null } | null };

export type DeclineTransactionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeclineTransactionMutation = { declineTransaction?: { errors: Array<string>, transaction?: { id: string } | null } | null };

export type UpdateTransactionStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: TransactionStatus;
}>;


export type UpdateTransactionStatusMutation = { updateTransactionStatus?: { errors: Array<string>, transaction?: { id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null } | null } | null };

export type DeactivateAdjustmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeactivateAdjustmentMutation = { deactivateAdjustment?: { errors: Array<string>, adjustment?: { id: string } | null } | null };

export type CreateSeasonMutationVariables = Exact<{
  year?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateSeasonMutation = { createSeason?: { errors: Array<string>, season?: { id: string, year: number } | null } | null };

export type ChangeSeasonMutationVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type ChangeSeasonMutation = { changeSeason?: { errors: Array<string>, season?: { id: string, year: number } | null } | null };

export type CreateDraftMutationVariables = Exact<{
  year: Scalars['Int']['input'];
}>;


export type CreateDraftMutation = { createDraft?: { errors: Array<string>, season?: { id: string, year: number, hasDraft: boolean, hasNegotiations: boolean } | null } | null };

export type SkipDraftPickMutationVariables = Exact<{
  input: SkipDraftPickInput;
}>;


export type SkipDraftPickMutation = { skipDraftPick?: { errors: Array<string>, draftPick?: { id: string } | null } | null };

export type FavoritePlayerMutationVariables = Exact<{
  input: FavoritePlayerInput;
}>;


export type FavoritePlayerMutation = { favoritePlayer?: { errors: Array<string>, player?: { id: string } | null } | null };

export type SaveFranchiseMutationVariables = Exact<{
  input: SaveFranchiseInput;
}>;


export type SaveFranchiseMutation = { saveFranchise?: { errors: Array<string>, franchise?: { id: string, name: string, motto?: string | null, logo?: string | null, color?: string | null, abbr?: string | null, phone?: string | null } | null } | null };

export type CreateTransactionAssetMutationVariables = Exact<{
  input: CreateTransactionAssetInput;
}>;


export type CreateTransactionAssetMutation = { createTransactionAsset?: { errors: Array<string>, transaction?: { id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null } | null } | null };

export type DeleteTransactionAssetMutationVariables = Exact<{
  input: DeleteTransactionAssetInput;
}>;


export type DeleteTransactionAssetMutation = { deleteTransactionAsset?: { errors: Array<string>, transaction?: { id: string, type: TransactionKind, date: string, status: TransactionStatus, rejectionMessages: Array<string>, note?: string | null, assets?: Array<{ __typename: 'AdjustmentAsset', id: string, salary?: number | null, note?: string | null, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, adjustmenPlayer?: { id: string, name: string } | null, adjustment?: { id: string } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'CapSpaceAsset', id: string, salary?: number | null, note?: string | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, season?: { id: string, year: number } | null } | { __typename: 'DraftPickAsset', id: string, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, draftPick: { id: string, pick?: number | null, round: number, salary?: number | null, skipped?: boolean | null, season?: { id: string, year: number } | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, originalFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null }, draftedPlayer?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null } | { __typename: 'PlayerAsset', id: string, previousDesignation?: string | null, previousSalary?: string | null, previousFranchise?: string | null, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, to?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, from?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, contract?: { id: string, salary?: number | null } | null, player: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } }> | null } | null } | null };

export type NominatePlayerMutationVariables = Exact<{
  playerId: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NominatePlayerMutation = { nominatePlayer?: { errors: Array<string>, auctionItem?: { id: string, status: AuctionItemStatus, currentBid: number, endsAt?: any | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null, leadingFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, bids: Array<{ id: string, amount: number, createdAt: any, franchise: { id: string, name: string, logo?: string | null } }> } | null } | null };

export type CreateBidMutationVariables = Exact<{
  amount: Scalars['Int']['input'];
  idempotencyKey: Scalars['String']['input'];
  auctionItemId: Scalars['ID']['input'];
}>;


export type CreateBidMutation = { createBid?: { errors: Array<string>, auctionItem?: { id: string, status: AuctionItemStatus, currentBid: number, endsAt?: any | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null, leadingFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, bids: Array<{ id: string, amount: number, createdAt: any, franchise: { id: string, name: string, logo?: string | null } }> } | null } | null };

export type CancelAuctionItemMutationVariables = Exact<{
  auctionItemId: Scalars['ID']['input'];
}>;


export type CancelAuctionItemMutation = { cancelAuctionItem?: { errors: Array<string>, auctionItem?: { id: string, status: AuctionItemStatus, currentBid: number, endsAt?: any | null, player?: { id: string, name: string, position: string, team?: string | null, years?: number | null, contract?: { id: string, salary?: number | null, designation?: { id: string, name: string, order?: number | null } | null, franchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, player: { id: string, name: string, position: string, team?: string | null, adp?: number | null } } | null } | null, leadingFranchise?: { id: string, name: string, logo?: string | null, abbr?: string | null } | null, bids: Array<{ id: string, amount: number, createdAt: any, franchise: { id: string, name: string, logo?: string | null } }> } | null } | null };

export type StartCountdownMutationVariables = Exact<{
  auctionItemId: Scalars['ID']['input'];
}>;


export type StartCountdownMutation = { startCountdown?: { success: boolean, errors: Array<string> } | null };

export type PauseCountdownMutationVariables = Exact<{
  auctionItemId: Scalars['ID']['input'];
}>;


export type PauseCountdownMutation = { pauseCountdown?: { success: boolean, errors: Array<string> } | null };

export type SendAuctionReactionMutationVariables = Exact<{
  auctionId: Scalars['ID']['input'];
  emoji: Scalars['String']['input'];
}>;


export type SendAuctionReactionMutation = { sendAuctionReaction?: { success: boolean } | null };

export const SeasonsWithMetaFieldsFragmentDoc = gql`
    fragment SeasonsWithMetaFields on Season {
  id
  year
  current
  hasDraft
  hasNegotiations
}
    `;
export const DesignationFieldsFragmentDoc = gql`
    fragment DesignationFields on Designation {
  id
  name
  order
}
    `;
export const FranchiseFieldsFragmentDoc = gql`
    fragment FranchiseFields on Franchise {
  id
  name
  logo
  abbr
}
    `;
export const ContractPlayerFieldsFragmentDoc = gql`
    fragment ContractPlayerFields on Player {
  id
  name
  position
  team
  adp
}
    `;
export const ContractFieldsFragmentDoc = gql`
    fragment ContractFields on Contract {
  id
  salary
  designation {
    ...DesignationFields
  }
  franchise {
    ...FranchiseFields
  }
  player {
    ...ContractPlayerFields
  }
}
    ${DesignationFieldsFragmentDoc}
${FranchiseFieldsFragmentDoc}
${ContractPlayerFieldsFragmentDoc}`;
export const PlayerFieldsFragmentDoc = gql`
    fragment PlayerFields on Player {
  id
  name
  position
  team
  years
  contract {
    ...ContractFields
  }
}
    ${ContractFieldsFragmentDoc}`;
export const PlayerAssetFieldsFragmentDoc = gql`
    fragment PlayerAssetFields on PlayerAsset {
  __typename
  id
  previousDesignation
  previousSalary
  previousFranchise
  salary
  designation {
    ...DesignationFields
  }
  to {
    ...FranchiseFields
  }
  from {
    ...FranchiseFields
  }
  contract {
    id
    salary
  }
  player {
    ...PlayerFields
  }
}
    ${DesignationFieldsFragmentDoc}
${FranchiseFieldsFragmentDoc}
${PlayerFieldsFragmentDoc}`;
export const SeasonsFieldsFragmentDoc = gql`
    fragment SeasonsFields on Season {
  id
  year
}
    `;
export const AdjustmentAssetFieldsFragmentDoc = gql`
    fragment AdjustmentAssetFields on AdjustmentAsset {
  __typename
  id
  salary
  note
  previousDesignation
  previousSalary
  previousFranchise
  adjustmenPlayer: player {
    id
    name
  }
  adjustment {
    id
  }
  to {
    ...FranchiseFields
  }
  season {
    ...SeasonsFields
  }
}
    ${FranchiseFieldsFragmentDoc}
${SeasonsFieldsFragmentDoc}`;
export const CapSpaceAssetFieldsFragmentDoc = gql`
    fragment CapSpaceAssetFields on CapSpaceAsset {
  __typename
  id
  salary
  note
  to {
    ...FranchiseFields
  }
  from {
    ...FranchiseFields
  }
  season {
    ...SeasonsFields
  }
}
    ${FranchiseFieldsFragmentDoc}
${SeasonsFieldsFragmentDoc}`;
export const DraftPickFieldsFragmentDoc = gql`
    fragment DraftPickFields on DraftPick {
  id
  pick
  round
  salary
  skipped
  season {
    ...SeasonsFields
  }
  designation {
    ...DesignationFields
  }
  franchise {
    ...FranchiseFields
  }
  originalFranchise {
    ...FranchiseFields
  }
  player {
    ...PlayerFields
  }
}
    ${SeasonsFieldsFragmentDoc}
${DesignationFieldsFragmentDoc}
${FranchiseFieldsFragmentDoc}
${PlayerFieldsFragmentDoc}`;
export const DraftPickAssetFieldsFragmentDoc = gql`
    fragment DraftPickAssetFields on DraftPickAsset {
  __typename
  id
  to {
    ...FranchiseFields
  }
  from {
    ...FranchiseFields
  }
  draftPick {
    ...DraftPickFields
  }
  draftedPlayer {
    ...PlayerFields
  }
}
    ${FranchiseFieldsFragmentDoc}
${DraftPickFieldsFragmentDoc}
${PlayerFieldsFragmentDoc}`;
export const FullTransactionFieldsFragmentDoc = gql`
    fragment FullTransactionFields on Transaction {
  id
  type
  date
  status
  rejectionMessages
  note
  assets {
    __typename
    ...PlayerAssetFields
    ...AdjustmentAssetFields
    ...CapSpaceAssetFields
    ...DraftPickAssetFields
  }
}
    ${PlayerAssetFieldsFragmentDoc}
${AdjustmentAssetFieldsFragmentDoc}
${CapSpaceAssetFieldsFragmentDoc}
${DraftPickAssetFieldsFragmentDoc}`;
export const AdjustmentFieldsFragmentDoc = gql`
    fragment AdjustmentFields on Adjustment {
  __typename
  id
  amount
  note
  season {
    ...SeasonsFields
  }
  player {
    id
    name
  }
}
    ${SeasonsFieldsFragmentDoc}`;
export const CapSpaceFieldsFragmentDoc = gql`
    fragment CapSpaceFields on CapSpace {
  __typename
  id
  amount
  note
  recipient {
    ...FranchiseFields
  }
  owner {
    ...FranchiseFields
  }
  season {
    ...SeasonsFields
  }
}
    ${FranchiseFieldsFragmentDoc}
${SeasonsFieldsFragmentDoc}`;
export const FranchiseExpandedFieldsFragmentDoc = gql`
    fragment FranchiseExpandedFields on Franchise {
  ...FranchiseFields
  phone
  order
  motto
  color
  availableCapSpace
  availableRosterSpots
  owner {
    id
    name
    email
  }
  contracts {
    ...ContractFields
  }
  adjustments {
    ...AdjustmentFields
  }
  availableDraftPicks {
    ...DraftPickFields
  }
  capSpacesGiven {
    ...CapSpaceFields
  }
  capSpacesReceived {
    ...CapSpaceFields
  }
}
    ${FranchiseFieldsFragmentDoc}
${ContractFieldsFragmentDoc}
${AdjustmentFieldsFragmentDoc}
${DraftPickFieldsFragmentDoc}
${CapSpaceFieldsFragmentDoc}`;
export const AuctionItemFieldsFragmentDoc = gql`
    fragment AuctionItemFields on AuctionItem {
  id
  status
  currentBid
  endsAt
  player {
    ...PlayerFields
  }
  leadingFranchise {
    ...FranchiseFields
  }
  bids {
    id
    amount
    createdAt
    franchise {
      id
      name
      logo
    }
  }
}
    ${PlayerFieldsFragmentDoc}
${FranchiseFieldsFragmentDoc}`;
export const AuctionFieldsFragmentDoc = gql`
    fragment AuctionFields on Auction {
  id
  status
  mode
  currentAuctionItem {
    ...AuctionItemFields
  }
}
    ${AuctionItemFieldsFragmentDoc}`;
export const TransactionSearchDocument = gql`
    query TransactionSearch($type: TransactionKind, $franchiseId: Int, $offset: Int, $status: String) {
  allTransactions(
    type: $type
    franchiseId: $franchiseId
    offset: $offset
    status: $status
  ) {
    total
    transactions {
      ...FullTransactionFields
    }
  }
}
    ${FullTransactionFieldsFragmentDoc}`;

/**
 * __useTransactionSearchQuery__
 *
 * To run a query within a React component, call `useTransactionSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionSearchQuery({
 *   variables: {
 *      type: // value for 'type'
 *      franchiseId: // value for 'franchiseId'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useTransactionSearchQuery(baseOptions?: Apollo.QueryHookOptions<TransactionSearchQuery, TransactionSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionSearchQuery, TransactionSearchQueryVariables>(TransactionSearchDocument, options);
      }
export function useTransactionSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionSearchQuery, TransactionSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionSearchQuery, TransactionSearchQueryVariables>(TransactionSearchDocument, options);
        }
export function useTransactionSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionSearchQuery, TransactionSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionSearchQuery, TransactionSearchQueryVariables>(TransactionSearchDocument, options);
        }
export type TransactionSearchQueryHookResult = ReturnType<typeof useTransactionSearchQuery>;
export type TransactionSearchLazyQueryHookResult = ReturnType<typeof useTransactionSearchLazyQuery>;
export type TransactionSearchSuspenseQueryHookResult = ReturnType<typeof useTransactionSearchSuspenseQuery>;
export type TransactionSearchQueryResult = Apollo.QueryResult<TransactionSearchQuery, TransactionSearchQueryVariables>;
export const DataDocument = gql`
    query Data($chart: String!) {
  data(chart: $chart) {
    chart
    data
    colors
    keys
  }
}
    `;

/**
 * __useDataQuery__
 *
 * To run a query within a React component, call `useDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataQuery({
 *   variables: {
 *      chart: // value for 'chart'
 *   },
 * });
 */
export function useDataQuery(baseOptions: Apollo.QueryHookOptions<DataQuery, DataQueryVariables> & ({ variables: DataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataQuery, DataQueryVariables>(DataDocument, options);
      }
export function useDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataQuery, DataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataQuery, DataQueryVariables>(DataDocument, options);
        }
export function useDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DataQuery, DataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DataQuery, DataQueryVariables>(DataDocument, options);
        }
export type DataQueryHookResult = ReturnType<typeof useDataQuery>;
export type DataLazyQueryHookResult = ReturnType<typeof useDataLazyQuery>;
export type DataSuspenseQueryHookResult = ReturnType<typeof useDataSuspenseQuery>;
export type DataQueryResult = Apollo.QueryResult<DataQuery, DataQueryVariables>;
export const PlayerDocument = gql`
    query Player($id: ID!, $includeHistory: Boolean = false) {
  player(id: $id) {
    __typename
    ...PlayerFields
    history @include(if: $includeHistory) {
      ...FullTransactionFields
    }
  }
}
    ${PlayerFieldsFragmentDoc}
${FullTransactionFieldsFragmentDoc}`;

/**
 * __usePlayerQuery__
 *
 * To run a query within a React component, call `usePlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeHistory: // value for 'includeHistory'
 *   },
 * });
 */
export function usePlayerQuery(baseOptions: Apollo.QueryHookOptions<PlayerQuery, PlayerQueryVariables> & ({ variables: PlayerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerQuery, PlayerQueryVariables>(PlayerDocument, options);
      }
export function usePlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerQuery, PlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerQuery, PlayerQueryVariables>(PlayerDocument, options);
        }
export function usePlayerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlayerQuery, PlayerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlayerQuery, PlayerQueryVariables>(PlayerDocument, options);
        }
export type PlayerQueryHookResult = ReturnType<typeof usePlayerQuery>;
export type PlayerLazyQueryHookResult = ReturnType<typeof usePlayerLazyQuery>;
export type PlayerSuspenseQueryHookResult = ReturnType<typeof usePlayerSuspenseQuery>;
export type PlayerQueryResult = Apollo.QueryResult<PlayerQuery, PlayerQueryVariables>;
export const AdjustmentDocument = gql`
    query Adjustment($id: ID!, $includeHistory: Boolean = false) {
  adjustment(id: $id) {
    __typename
    id
    amount
    note
    history @include(if: $includeHistory) {
      ...FullTransactionFields
    }
  }
}
    ${FullTransactionFieldsFragmentDoc}`;

/**
 * __useAdjustmentQuery__
 *
 * To run a query within a React component, call `useAdjustmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdjustmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdjustmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeHistory: // value for 'includeHistory'
 *   },
 * });
 */
export function useAdjustmentQuery(baseOptions: Apollo.QueryHookOptions<AdjustmentQuery, AdjustmentQueryVariables> & ({ variables: AdjustmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdjustmentQuery, AdjustmentQueryVariables>(AdjustmentDocument, options);
      }
export function useAdjustmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdjustmentQuery, AdjustmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdjustmentQuery, AdjustmentQueryVariables>(AdjustmentDocument, options);
        }
export function useAdjustmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdjustmentQuery, AdjustmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdjustmentQuery, AdjustmentQueryVariables>(AdjustmentDocument, options);
        }
export type AdjustmentQueryHookResult = ReturnType<typeof useAdjustmentQuery>;
export type AdjustmentLazyQueryHookResult = ReturnType<typeof useAdjustmentLazyQuery>;
export type AdjustmentSuspenseQueryHookResult = ReturnType<typeof useAdjustmentSuspenseQuery>;
export type AdjustmentQueryResult = Apollo.QueryResult<AdjustmentQuery, AdjustmentQueryVariables>;
export const DraftPickDocument = gql`
    query DraftPick($id: ID!, $includeHistory: Boolean = false) {
  draftPick(id: $id) {
    __typename
    ...DraftPickFields
    history @include(if: $includeHistory) {
      ...FullTransactionFields
    }
  }
}
    ${DraftPickFieldsFragmentDoc}
${FullTransactionFieldsFragmentDoc}`;

/**
 * __useDraftPickQuery__
 *
 * To run a query within a React component, call `useDraftPickQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftPickQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftPickQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeHistory: // value for 'includeHistory'
 *   },
 * });
 */
export function useDraftPickQuery(baseOptions: Apollo.QueryHookOptions<DraftPickQuery, DraftPickQueryVariables> & ({ variables: DraftPickQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftPickQuery, DraftPickQueryVariables>(DraftPickDocument, options);
      }
export function useDraftPickLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftPickQuery, DraftPickQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftPickQuery, DraftPickQueryVariables>(DraftPickDocument, options);
        }
export function useDraftPickSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftPickQuery, DraftPickQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftPickQuery, DraftPickQueryVariables>(DraftPickDocument, options);
        }
export type DraftPickQueryHookResult = ReturnType<typeof useDraftPickQuery>;
export type DraftPickLazyQueryHookResult = ReturnType<typeof useDraftPickLazyQuery>;
export type DraftPickSuspenseQueryHookResult = ReturnType<typeof useDraftPickSuspenseQuery>;
export type DraftPickQueryResult = Apollo.QueryResult<DraftPickQuery, DraftPickQueryVariables>;
export const TransactionDocument = gql`
    query Transaction($id: ID!) {
  transaction(id: $id) {
    ...FullTransactionFields
    season {
      year
    }
  }
}
    ${FullTransactionFieldsFragmentDoc}`;

/**
 * __useTransactionQuery__
 *
 * To run a query within a React component, call `useTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransactionQuery(baseOptions: Apollo.QueryHookOptions<TransactionQuery, TransactionQueryVariables> & ({ variables: TransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
      }
export function useTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionQuery, TransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
        }
export function useTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionQuery, TransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
        }
export type TransactionQueryHookResult = ReturnType<typeof useTransactionQuery>;
export type TransactionLazyQueryHookResult = ReturnType<typeof useTransactionLazyQuery>;
export type TransactionSuspenseQueryHookResult = ReturnType<typeof useTransactionSuspenseQuery>;
export type TransactionQueryResult = Apollo.QueryResult<TransactionQuery, TransactionQueryVariables>;
export const OffseasonNegotiationDocument = gql`
    query OffseasonNegotiation($franchiseId: ID!, $season: Int!) {
  offseasonNegotiation(franchiseId: $franchiseId, season: $season) {
    ...FullTransactionFields
  }
}
    ${FullTransactionFieldsFragmentDoc}`;

/**
 * __useOffseasonNegotiationQuery__
 *
 * To run a query within a React component, call `useOffseasonNegotiationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffseasonNegotiationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffseasonNegotiationQuery({
 *   variables: {
 *      franchiseId: // value for 'franchiseId'
 *      season: // value for 'season'
 *   },
 * });
 */
export function useOffseasonNegotiationQuery(baseOptions: Apollo.QueryHookOptions<OffseasonNegotiationQuery, OffseasonNegotiationQueryVariables> & ({ variables: OffseasonNegotiationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffseasonNegotiationQuery, OffseasonNegotiationQueryVariables>(OffseasonNegotiationDocument, options);
      }
export function useOffseasonNegotiationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffseasonNegotiationQuery, OffseasonNegotiationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffseasonNegotiationQuery, OffseasonNegotiationQueryVariables>(OffseasonNegotiationDocument, options);
        }
export function useOffseasonNegotiationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffseasonNegotiationQuery, OffseasonNegotiationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffseasonNegotiationQuery, OffseasonNegotiationQueryVariables>(OffseasonNegotiationDocument, options);
        }
export type OffseasonNegotiationQueryHookResult = ReturnType<typeof useOffseasonNegotiationQuery>;
export type OffseasonNegotiationLazyQueryHookResult = ReturnType<typeof useOffseasonNegotiationLazyQuery>;
export type OffseasonNegotiationSuspenseQueryHookResult = ReturnType<typeof useOffseasonNegotiationSuspenseQuery>;
export type OffseasonNegotiationQueryResult = Apollo.QueryResult<OffseasonNegotiationQuery, OffseasonNegotiationQueryVariables>;
export const OffseasonNegotiationsDocument = gql`
    query OffseasonNegotiations($season: Int!) {
  offseasonNegotiations(season: $season) {
    id
    type
    date
    status
    note
    franchise {
      id
      name
      logo
      abbr
    }
  }
}
    `;

/**
 * __useOffseasonNegotiationsQuery__
 *
 * To run a query within a React component, call `useOffseasonNegotiationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffseasonNegotiationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffseasonNegotiationsQuery({
 *   variables: {
 *      season: // value for 'season'
 *   },
 * });
 */
export function useOffseasonNegotiationsQuery(baseOptions: Apollo.QueryHookOptions<OffseasonNegotiationsQuery, OffseasonNegotiationsQueryVariables> & ({ variables: OffseasonNegotiationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffseasonNegotiationsQuery, OffseasonNegotiationsQueryVariables>(OffseasonNegotiationsDocument, options);
      }
export function useOffseasonNegotiationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffseasonNegotiationsQuery, OffseasonNegotiationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffseasonNegotiationsQuery, OffseasonNegotiationsQueryVariables>(OffseasonNegotiationsDocument, options);
        }
export function useOffseasonNegotiationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffseasonNegotiationsQuery, OffseasonNegotiationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffseasonNegotiationsQuery, OffseasonNegotiationsQueryVariables>(OffseasonNegotiationsDocument, options);
        }
export type OffseasonNegotiationsQueryHookResult = ReturnType<typeof useOffseasonNegotiationsQuery>;
export type OffseasonNegotiationsLazyQueryHookResult = ReturnType<typeof useOffseasonNegotiationsLazyQuery>;
export type OffseasonNegotiationsSuspenseQueryHookResult = ReturnType<typeof useOffseasonNegotiationsSuspenseQuery>;
export type OffseasonNegotiationsQueryResult = Apollo.QueryResult<OffseasonNegotiationsQuery, OffseasonNegotiationsQueryVariables>;
export const FavoritesDocument = gql`
    query Favorites {
  favorites {
    id
  }
}
    `;

/**
 * __useFavoritesQuery__
 *
 * To run a query within a React component, call `useFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<FavoritesQuery, FavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoritesQuery, FavoritesQueryVariables>(FavoritesDocument, options);
      }
export function useFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoritesQuery, FavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoritesQuery, FavoritesQueryVariables>(FavoritesDocument, options);
        }
export function useFavoritesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoritesQuery, FavoritesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavoritesQuery, FavoritesQueryVariables>(FavoritesDocument, options);
        }
export type FavoritesQueryHookResult = ReturnType<typeof useFavoritesQuery>;
export type FavoritesLazyQueryHookResult = ReturnType<typeof useFavoritesLazyQuery>;
export type FavoritesSuspenseQueryHookResult = ReturnType<typeof useFavoritesSuspenseQuery>;
export type FavoritesQueryResult = Apollo.QueryResult<FavoritesQuery, FavoritesQueryVariables>;
export const FavoritesPlayersDocument = gql`
    query FavoritesPlayers {
  favorites {
    ...PlayerFields
  }
}
    ${PlayerFieldsFragmentDoc}`;

/**
 * __useFavoritesPlayersQuery__
 *
 * To run a query within a React component, call `useFavoritesPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoritesPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoritesPlayersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoritesPlayersQuery(baseOptions?: Apollo.QueryHookOptions<FavoritesPlayersQuery, FavoritesPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoritesPlayersQuery, FavoritesPlayersQueryVariables>(FavoritesPlayersDocument, options);
      }
export function useFavoritesPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoritesPlayersQuery, FavoritesPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoritesPlayersQuery, FavoritesPlayersQueryVariables>(FavoritesPlayersDocument, options);
        }
export function useFavoritesPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoritesPlayersQuery, FavoritesPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavoritesPlayersQuery, FavoritesPlayersQueryVariables>(FavoritesPlayersDocument, options);
        }
export type FavoritesPlayersQueryHookResult = ReturnType<typeof useFavoritesPlayersQuery>;
export type FavoritesPlayersLazyQueryHookResult = ReturnType<typeof useFavoritesPlayersLazyQuery>;
export type FavoritesPlayersSuspenseQueryHookResult = ReturnType<typeof useFavoritesPlayersSuspenseQuery>;
export type FavoritesPlayersQueryResult = Apollo.QueryResult<FavoritesPlayersQuery, FavoritesPlayersQueryVariables>;
export const AllPlayersDocument = gql`
    query AllPlayers($search: String, $position: String, $offset: Int, $limit: Int, $status: String, $contract: String, $favorites: Boolean, $rookies: Boolean, $sortOrder: String) {
  allPlayers(
    search: $search
    position: $position
    offset: $offset
    limit: $limit
    status: $status
    contract: $contract
    favorites: $favorites
    rookies: $rookies
    sortOrder: $sortOrder
  ) {
    total
    players {
      ...PlayerFields
    }
  }
}
    ${PlayerFieldsFragmentDoc}`;

/**
 * __useAllPlayersQuery__
 *
 * To run a query within a React component, call `useAllPlayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlayersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlayersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      position: // value for 'position'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      status: // value for 'status'
 *      contract: // value for 'contract'
 *      favorites: // value for 'favorites'
 *      rookies: // value for 'rookies'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useAllPlayersQuery(baseOptions?: Apollo.QueryHookOptions<AllPlayersQuery, AllPlayersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlayersQuery, AllPlayersQueryVariables>(AllPlayersDocument, options);
      }
export function useAllPlayersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlayersQuery, AllPlayersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlayersQuery, AllPlayersQueryVariables>(AllPlayersDocument, options);
        }
export function useAllPlayersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPlayersQuery, AllPlayersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPlayersQuery, AllPlayersQueryVariables>(AllPlayersDocument, options);
        }
export type AllPlayersQueryHookResult = ReturnType<typeof useAllPlayersQuery>;
export type AllPlayersLazyQueryHookResult = ReturnType<typeof useAllPlayersLazyQuery>;
export type AllPlayersSuspenseQueryHookResult = ReturnType<typeof useAllPlayersSuspenseQuery>;
export type AllPlayersQueryResult = Apollo.QueryResult<AllPlayersQuery, AllPlayersQueryVariables>;
export const FranchisesDocument = gql`
    query Franchises {
  franchises {
    ...FranchiseExpandedFields
  }
}
    ${FranchiseExpandedFieldsFragmentDoc}`;

/**
 * __useFranchisesQuery__
 *
 * To run a query within a React component, call `useFranchisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFranchisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFranchisesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFranchisesQuery(baseOptions?: Apollo.QueryHookOptions<FranchisesQuery, FranchisesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FranchisesQuery, FranchisesQueryVariables>(FranchisesDocument, options);
      }
export function useFranchisesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FranchisesQuery, FranchisesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FranchisesQuery, FranchisesQueryVariables>(FranchisesDocument, options);
        }
export function useFranchisesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FranchisesQuery, FranchisesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FranchisesQuery, FranchisesQueryVariables>(FranchisesDocument, options);
        }
export type FranchisesQueryHookResult = ReturnType<typeof useFranchisesQuery>;
export type FranchisesLazyQueryHookResult = ReturnType<typeof useFranchisesLazyQuery>;
export type FranchisesSuspenseQueryHookResult = ReturnType<typeof useFranchisesSuspenseQuery>;
export type FranchisesQueryResult = Apollo.QueryResult<FranchisesQuery, FranchisesQueryVariables>;
export const DesignationsDocument = gql`
    query Designations {
  designations {
    ...DesignationFields
  }
}
    ${DesignationFieldsFragmentDoc}`;

/**
 * __useDesignationsQuery__
 *
 * To run a query within a React component, call `useDesignationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDesignationsQuery(baseOptions?: Apollo.QueryHookOptions<DesignationsQuery, DesignationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DesignationsQuery, DesignationsQueryVariables>(DesignationsDocument, options);
      }
export function useDesignationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DesignationsQuery, DesignationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DesignationsQuery, DesignationsQueryVariables>(DesignationsDocument, options);
        }
export function useDesignationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DesignationsQuery, DesignationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DesignationsQuery, DesignationsQueryVariables>(DesignationsDocument, options);
        }
export type DesignationsQueryHookResult = ReturnType<typeof useDesignationsQuery>;
export type DesignationsLazyQueryHookResult = ReturnType<typeof useDesignationsLazyQuery>;
export type DesignationsSuspenseQueryHookResult = ReturnType<typeof useDesignationsSuspenseQuery>;
export type DesignationsQueryResult = Apollo.QueryResult<DesignationsQuery, DesignationsQueryVariables>;
export const YearsDocument = gql`
    query Years {
  years
}
    `;

/**
 * __useYearsQuery__
 *
 * To run a query within a React component, call `useYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useYearsQuery(baseOptions?: Apollo.QueryHookOptions<YearsQuery, YearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YearsQuery, YearsQueryVariables>(YearsDocument, options);
      }
export function useYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YearsQuery, YearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YearsQuery, YearsQueryVariables>(YearsDocument, options);
        }
export function useYearsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YearsQuery, YearsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YearsQuery, YearsQueryVariables>(YearsDocument, options);
        }
export type YearsQueryHookResult = ReturnType<typeof useYearsQuery>;
export type YearsLazyQueryHookResult = ReturnType<typeof useYearsLazyQuery>;
export type YearsSuspenseQueryHookResult = ReturnType<typeof useYearsSuspenseQuery>;
export type YearsQueryResult = Apollo.QueryResult<YearsQuery, YearsQueryVariables>;
export const SeasonsDocument = gql`
    query Seasons {
  seasons {
    ...SeasonsWithMetaFields
  }
}
    ${SeasonsWithMetaFieldsFragmentDoc}`;

/**
 * __useSeasonsQuery__
 *
 * To run a query within a React component, call `useSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSeasonsQuery(baseOptions?: Apollo.QueryHookOptions<SeasonsQuery, SeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeasonsQuery, SeasonsQueryVariables>(SeasonsDocument, options);
      }
export function useSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeasonsQuery, SeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeasonsQuery, SeasonsQueryVariables>(SeasonsDocument, options);
        }
export function useSeasonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SeasonsQuery, SeasonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SeasonsQuery, SeasonsQueryVariables>(SeasonsDocument, options);
        }
export type SeasonsQueryHookResult = ReturnType<typeof useSeasonsQuery>;
export type SeasonsLazyQueryHookResult = ReturnType<typeof useSeasonsLazyQuery>;
export type SeasonsSuspenseQueryHookResult = ReturnType<typeof useSeasonsSuspenseQuery>;
export type SeasonsQueryResult = Apollo.QueryResult<SeasonsQuery, SeasonsQueryVariables>;
export const DraftPicksDocument = gql`
    query DraftPicks($onlyAvailable: Boolean!, $franchiseId: ID, $year: Int) {
  draftPicks(
    onlyAvailable: $onlyAvailable
    franchiseId: $franchiseId
    year: $year
  ) {
    ...DraftPickFields
  }
}
    ${DraftPickFieldsFragmentDoc}`;

/**
 * __useDraftPicksQuery__
 *
 * To run a query within a React component, call `useDraftPicksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftPicksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftPicksQuery({
 *   variables: {
 *      onlyAvailable: // value for 'onlyAvailable'
 *      franchiseId: // value for 'franchiseId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDraftPicksQuery(baseOptions: Apollo.QueryHookOptions<DraftPicksQuery, DraftPicksQueryVariables> & ({ variables: DraftPicksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftPicksQuery, DraftPicksQueryVariables>(DraftPicksDocument, options);
      }
export function useDraftPicksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftPicksQuery, DraftPicksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftPicksQuery, DraftPicksQueryVariables>(DraftPicksDocument, options);
        }
export function useDraftPicksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftPicksQuery, DraftPicksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftPicksQuery, DraftPicksQueryVariables>(DraftPicksDocument, options);
        }
export type DraftPicksQueryHookResult = ReturnType<typeof useDraftPicksQuery>;
export type DraftPicksLazyQueryHookResult = ReturnType<typeof useDraftPicksLazyQuery>;
export type DraftPicksSuspenseQueryHookResult = ReturnType<typeof useDraftPicksSuspenseQuery>;
export type DraftPicksQueryResult = Apollo.QueryResult<DraftPicksQuery, DraftPicksQueryVariables>;
export const FranchiseDocument = gql`
    query Franchise($id: ID!) {
  franchise(id: $id) {
    ...FranchiseExpandedFields
  }
}
    ${FranchiseExpandedFieldsFragmentDoc}`;

/**
 * __useFranchiseQuery__
 *
 * To run a query within a React component, call `useFranchiseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFranchiseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFranchiseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFranchiseQuery(baseOptions: Apollo.QueryHookOptions<FranchiseQuery, FranchiseQueryVariables> & ({ variables: FranchiseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FranchiseQuery, FranchiseQueryVariables>(FranchiseDocument, options);
      }
export function useFranchiseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FranchiseQuery, FranchiseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FranchiseQuery, FranchiseQueryVariables>(FranchiseDocument, options);
        }
export function useFranchiseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FranchiseQuery, FranchiseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FranchiseQuery, FranchiseQueryVariables>(FranchiseDocument, options);
        }
export type FranchiseQueryHookResult = ReturnType<typeof useFranchiseQuery>;
export type FranchiseLazyQueryHookResult = ReturnType<typeof useFranchiseLazyQuery>;
export type FranchiseSuspenseQueryHookResult = ReturnType<typeof useFranchiseSuspenseQuery>;
export type FranchiseQueryResult = Apollo.QueryResult<FranchiseQuery, FranchiseQueryVariables>;
export const FranchiseStatusDocument = gql`
    query FranchiseStatus($id: ID!) {
  franchise(id: $id) {
    id
    logo
    availableCapSpace
    availableRosterSpots
  }
}
    `;

/**
 * __useFranchiseStatusQuery__
 *
 * To run a query within a React component, call `useFranchiseStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFranchiseStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFranchiseStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFranchiseStatusQuery(baseOptions: Apollo.QueryHookOptions<FranchiseStatusQuery, FranchiseStatusQueryVariables> & ({ variables: FranchiseStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FranchiseStatusQuery, FranchiseStatusQueryVariables>(FranchiseStatusDocument, options);
      }
export function useFranchiseStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FranchiseStatusQuery, FranchiseStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FranchiseStatusQuery, FranchiseStatusQueryVariables>(FranchiseStatusDocument, options);
        }
export function useFranchiseStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FranchiseStatusQuery, FranchiseStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FranchiseStatusQuery, FranchiseStatusQueryVariables>(FranchiseStatusDocument, options);
        }
export type FranchiseStatusQueryHookResult = ReturnType<typeof useFranchiseStatusQuery>;
export type FranchiseStatusLazyQueryHookResult = ReturnType<typeof useFranchiseStatusLazyQuery>;
export type FranchiseStatusSuspenseQueryHookResult = ReturnType<typeof useFranchiseStatusSuspenseQuery>;
export type FranchiseStatusQueryResult = Apollo.QueryResult<FranchiseStatusQuery, FranchiseStatusQueryVariables>;
export const AuctionDocument = gql`
    query Auction {
  auction {
    ...AuctionFields
  }
}
    ${AuctionFieldsFragmentDoc}`;

/**
 * __useAuctionQuery__
 *
 * To run a query within a React component, call `useAuctionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuctionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuctionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuctionQuery(baseOptions?: Apollo.QueryHookOptions<AuctionQuery, AuctionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuctionQuery, AuctionQueryVariables>(AuctionDocument, options);
      }
export function useAuctionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuctionQuery, AuctionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuctionQuery, AuctionQueryVariables>(AuctionDocument, options);
        }
export function useAuctionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuctionQuery, AuctionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuctionQuery, AuctionQueryVariables>(AuctionDocument, options);
        }
export type AuctionQueryHookResult = ReturnType<typeof useAuctionQuery>;
export type AuctionLazyQueryHookResult = ReturnType<typeof useAuctionLazyQuery>;
export type AuctionSuspenseQueryHookResult = ReturnType<typeof useAuctionSuspenseQuery>;
export type AuctionQueryResult = Apollo.QueryResult<AuctionQuery, AuctionQueryVariables>;
export const DraftHubFranchisesDocument = gql`
    query DraftHubFranchises {
  draftHubFranchises {
    id
    name
    abbr
    logo
    color
    availableCapSpace
    availableRosterSpots
    contracts {
      id
      salary
      designation {
        id
        name
      }
      player {
        id
        name
        position
        team
        adp
      }
    }
  }
}
    `;

/**
 * __useDraftHubFranchisesQuery__
 *
 * To run a query within a React component, call `useDraftHubFranchisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftHubFranchisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftHubFranchisesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDraftHubFranchisesQuery(baseOptions?: Apollo.QueryHookOptions<DraftHubFranchisesQuery, DraftHubFranchisesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftHubFranchisesQuery, DraftHubFranchisesQueryVariables>(DraftHubFranchisesDocument, options);
      }
export function useDraftHubFranchisesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftHubFranchisesQuery, DraftHubFranchisesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftHubFranchisesQuery, DraftHubFranchisesQueryVariables>(DraftHubFranchisesDocument, options);
        }
export function useDraftHubFranchisesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftHubFranchisesQuery, DraftHubFranchisesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftHubFranchisesQuery, DraftHubFranchisesQueryVariables>(DraftHubFranchisesDocument, options);
        }
export type DraftHubFranchisesQueryHookResult = ReturnType<typeof useDraftHubFranchisesQuery>;
export type DraftHubFranchisesLazyQueryHookResult = ReturnType<typeof useDraftHubFranchisesLazyQuery>;
export type DraftHubFranchisesSuspenseQueryHookResult = ReturnType<typeof useDraftHubFranchisesSuspenseQuery>;
export type DraftHubFranchisesQueryResult = Apollo.QueryResult<DraftHubFranchisesQuery, DraftHubFranchisesQueryVariables>;
export const DraftHubAuctionDocument = gql`
    query DraftHubAuction {
  auction {
    id
    completedItems {
      player {
        id
      }
      leadingFranchise {
        id
      }
    }
  }
}
    `;

/**
 * __useDraftHubAuctionQuery__
 *
 * To run a query within a React component, call `useDraftHubAuctionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftHubAuctionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftHubAuctionQuery({
 *   variables: {
 *   },
 * });
 */
export function useDraftHubAuctionQuery(baseOptions?: Apollo.QueryHookOptions<DraftHubAuctionQuery, DraftHubAuctionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftHubAuctionQuery, DraftHubAuctionQueryVariables>(DraftHubAuctionDocument, options);
      }
export function useDraftHubAuctionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftHubAuctionQuery, DraftHubAuctionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftHubAuctionQuery, DraftHubAuctionQueryVariables>(DraftHubAuctionDocument, options);
        }
export function useDraftHubAuctionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DraftHubAuctionQuery, DraftHubAuctionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DraftHubAuctionQuery, DraftHubAuctionQueryVariables>(DraftHubAuctionDocument, options);
        }
export type DraftHubAuctionQueryHookResult = ReturnType<typeof useDraftHubAuctionQuery>;
export type DraftHubAuctionLazyQueryHookResult = ReturnType<typeof useDraftHubAuctionLazyQuery>;
export type DraftHubAuctionSuspenseQueryHookResult = ReturnType<typeof useDraftHubAuctionSuspenseQuery>;
export type DraftHubAuctionQueryResult = Apollo.QueryResult<DraftHubAuctionQuery, DraftHubAuctionQueryVariables>;
export const LoginUserDocument = gql`
    mutation LoginUser($email: String!, $password: String!) {
  login(input: {email: $email, password: $password}) {
    token
    errors
  }
}
    `;
export type LoginUserMutationFn = Apollo.MutationFunction<LoginUserMutation, LoginUserMutationVariables>;

/**
 * __useLoginUserMutation__
 *
 * To run a mutation, you first call `useLoginUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserMutation, { data, loading, error }] = useLoginUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginUserMutation, LoginUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginUserMutation, LoginUserMutationVariables>(LoginUserDocument, options);
      }
export type LoginUserMutationHookResult = ReturnType<typeof useLoginUserMutation>;
export type LoginUserMutationResult = Apollo.MutationResult<LoginUserMutation>;
export type LoginUserMutationOptions = Apollo.BaseMutationOptions<LoginUserMutation, LoginUserMutationVariables>;
export const CreateTransactionDocument = gql`
    mutation CreateTransaction($input: CreateTransactionInput!) {
  createTransaction(input: $input) {
    transaction {
      id
    }
    errors
  }
}
    `;
export type CreateTransactionMutationFn = Apollo.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const ApproveTransactionDocument = gql`
    mutation ApproveTransaction($id: ID!) {
  approveTransaction(input: {id: $id}) {
    transaction {
      id
      type
      season {
        year
      }
    }
    errors
  }
}
    `;
export type ApproveTransactionMutationFn = Apollo.MutationFunction<ApproveTransactionMutation, ApproveTransactionMutationVariables>;

/**
 * __useApproveTransactionMutation__
 *
 * To run a mutation, you first call `useApproveTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTransactionMutation, { data, loading, error }] = useApproveTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveTransactionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTransactionMutation, ApproveTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTransactionMutation, ApproveTransactionMutationVariables>(ApproveTransactionDocument, options);
      }
export type ApproveTransactionMutationHookResult = ReturnType<typeof useApproveTransactionMutation>;
export type ApproveTransactionMutationResult = Apollo.MutationResult<ApproveTransactionMutation>;
export type ApproveTransactionMutationOptions = Apollo.BaseMutationOptions<ApproveTransactionMutation, ApproveTransactionMutationVariables>;
export const DeclineTransactionDocument = gql`
    mutation DeclineTransaction($id: ID!) {
  declineTransaction(input: {id: $id}) {
    transaction {
      id
    }
    errors
  }
}
    `;
export type DeclineTransactionMutationFn = Apollo.MutationFunction<DeclineTransactionMutation, DeclineTransactionMutationVariables>;

/**
 * __useDeclineTransactionMutation__
 *
 * To run a mutation, you first call `useDeclineTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineTransactionMutation, { data, loading, error }] = useDeclineTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeclineTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeclineTransactionMutation, DeclineTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineTransactionMutation, DeclineTransactionMutationVariables>(DeclineTransactionDocument, options);
      }
export type DeclineTransactionMutationHookResult = ReturnType<typeof useDeclineTransactionMutation>;
export type DeclineTransactionMutationResult = Apollo.MutationResult<DeclineTransactionMutation>;
export type DeclineTransactionMutationOptions = Apollo.BaseMutationOptions<DeclineTransactionMutation, DeclineTransactionMutationVariables>;
export const UpdateTransactionStatusDocument = gql`
    mutation UpdateTransactionStatus($id: ID!, $status: TransactionStatus!) {
  updateTransactionStatus(input: {id: $id, status: $status}) {
    transaction {
      ...FullTransactionFields
    }
    errors
  }
}
    ${FullTransactionFieldsFragmentDoc}`;
export type UpdateTransactionStatusMutationFn = Apollo.MutationFunction<UpdateTransactionStatusMutation, UpdateTransactionStatusMutationVariables>;

/**
 * __useUpdateTransactionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionStatusMutation, { data, loading, error }] = useUpdateTransactionStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateTransactionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionStatusMutation, UpdateTransactionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionStatusMutation, UpdateTransactionStatusMutationVariables>(UpdateTransactionStatusDocument, options);
      }
export type UpdateTransactionStatusMutationHookResult = ReturnType<typeof useUpdateTransactionStatusMutation>;
export type UpdateTransactionStatusMutationResult = Apollo.MutationResult<UpdateTransactionStatusMutation>;
export type UpdateTransactionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionStatusMutation, UpdateTransactionStatusMutationVariables>;
export const DeactivateAdjustmentDocument = gql`
    mutation DeactivateAdjustment($id: ID!) {
  deactivateAdjustment(input: {id: $id}) {
    adjustment {
      id
    }
    errors
  }
}
    `;
export type DeactivateAdjustmentMutationFn = Apollo.MutationFunction<DeactivateAdjustmentMutation, DeactivateAdjustmentMutationVariables>;

/**
 * __useDeactivateAdjustmentMutation__
 *
 * To run a mutation, you first call `useDeactivateAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAdjustmentMutation, { data, loading, error }] = useDeactivateAdjustmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAdjustmentMutation, DeactivateAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAdjustmentMutation, DeactivateAdjustmentMutationVariables>(DeactivateAdjustmentDocument, options);
      }
export type DeactivateAdjustmentMutationHookResult = ReturnType<typeof useDeactivateAdjustmentMutation>;
export type DeactivateAdjustmentMutationResult = Apollo.MutationResult<DeactivateAdjustmentMutation>;
export type DeactivateAdjustmentMutationOptions = Apollo.BaseMutationOptions<DeactivateAdjustmentMutation, DeactivateAdjustmentMutationVariables>;
export const CreateSeasonDocument = gql`
    mutation CreateSeason($year: Int) {
  createSeason(input: {year: $year}) {
    season {
      id
      year
    }
    errors
  }
}
    `;
export type CreateSeasonMutationFn = Apollo.MutationFunction<CreateSeasonMutation, CreateSeasonMutationVariables>;

/**
 * __useCreateSeasonMutation__
 *
 * To run a mutation, you first call `useCreateSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSeasonMutation, { data, loading, error }] = useCreateSeasonMutation({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useCreateSeasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateSeasonMutation, CreateSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSeasonMutation, CreateSeasonMutationVariables>(CreateSeasonDocument, options);
      }
export type CreateSeasonMutationHookResult = ReturnType<typeof useCreateSeasonMutation>;
export type CreateSeasonMutationResult = Apollo.MutationResult<CreateSeasonMutation>;
export type CreateSeasonMutationOptions = Apollo.BaseMutationOptions<CreateSeasonMutation, CreateSeasonMutationVariables>;
export const ChangeSeasonDocument = gql`
    mutation ChangeSeason($year: Int!) {
  changeSeason(input: {year: $year}) {
    season {
      id
      year
    }
    errors
  }
}
    `;
export type ChangeSeasonMutationFn = Apollo.MutationFunction<ChangeSeasonMutation, ChangeSeasonMutationVariables>;

/**
 * __useChangeSeasonMutation__
 *
 * To run a mutation, you first call `useChangeSeasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSeasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSeasonMutation, { data, loading, error }] = useChangeSeasonMutation({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useChangeSeasonMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSeasonMutation, ChangeSeasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSeasonMutation, ChangeSeasonMutationVariables>(ChangeSeasonDocument, options);
      }
export type ChangeSeasonMutationHookResult = ReturnType<typeof useChangeSeasonMutation>;
export type ChangeSeasonMutationResult = Apollo.MutationResult<ChangeSeasonMutation>;
export type ChangeSeasonMutationOptions = Apollo.BaseMutationOptions<ChangeSeasonMutation, ChangeSeasonMutationVariables>;
export const CreateDraftDocument = gql`
    mutation CreateDraft($year: Int!) {
  createDraft(input: {year: $year}) {
    season {
      id
      year
      hasDraft
      hasNegotiations
    }
    errors
  }
}
    `;
export type CreateDraftMutationFn = Apollo.MutationFunction<CreateDraftMutation, CreateDraftMutationVariables>;

/**
 * __useCreateDraftMutation__
 *
 * To run a mutation, you first call `useCreateDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftMutation, { data, loading, error }] = useCreateDraftMutation({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useCreateDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftMutation, CreateDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDraftMutation, CreateDraftMutationVariables>(CreateDraftDocument, options);
      }
export type CreateDraftMutationHookResult = ReturnType<typeof useCreateDraftMutation>;
export type CreateDraftMutationResult = Apollo.MutationResult<CreateDraftMutation>;
export type CreateDraftMutationOptions = Apollo.BaseMutationOptions<CreateDraftMutation, CreateDraftMutationVariables>;
export const SkipDraftPickDocument = gql`
    mutation SkipDraftPick($input: SkipDraftPickInput!) {
  skipDraftPick(input: $input) {
    draftPick {
      id
    }
    errors
  }
}
    `;
export type SkipDraftPickMutationFn = Apollo.MutationFunction<SkipDraftPickMutation, SkipDraftPickMutationVariables>;

/**
 * __useSkipDraftPickMutation__
 *
 * To run a mutation, you first call `useSkipDraftPickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipDraftPickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipDraftPickMutation, { data, loading, error }] = useSkipDraftPickMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipDraftPickMutation(baseOptions?: Apollo.MutationHookOptions<SkipDraftPickMutation, SkipDraftPickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipDraftPickMutation, SkipDraftPickMutationVariables>(SkipDraftPickDocument, options);
      }
export type SkipDraftPickMutationHookResult = ReturnType<typeof useSkipDraftPickMutation>;
export type SkipDraftPickMutationResult = Apollo.MutationResult<SkipDraftPickMutation>;
export type SkipDraftPickMutationOptions = Apollo.BaseMutationOptions<SkipDraftPickMutation, SkipDraftPickMutationVariables>;
export const FavoritePlayerDocument = gql`
    mutation FavoritePlayer($input: FavoritePlayerInput!) {
  favoritePlayer(input: $input) {
    player {
      id
    }
    errors
  }
}
    `;
export type FavoritePlayerMutationFn = Apollo.MutationFunction<FavoritePlayerMutation, FavoritePlayerMutationVariables>;

/**
 * __useFavoritePlayerMutation__
 *
 * To run a mutation, you first call `useFavoritePlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavoritePlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favoritePlayerMutation, { data, loading, error }] = useFavoritePlayerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFavoritePlayerMutation(baseOptions?: Apollo.MutationHookOptions<FavoritePlayerMutation, FavoritePlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavoritePlayerMutation, FavoritePlayerMutationVariables>(FavoritePlayerDocument, options);
      }
export type FavoritePlayerMutationHookResult = ReturnType<typeof useFavoritePlayerMutation>;
export type FavoritePlayerMutationResult = Apollo.MutationResult<FavoritePlayerMutation>;
export type FavoritePlayerMutationOptions = Apollo.BaseMutationOptions<FavoritePlayerMutation, FavoritePlayerMutationVariables>;
export const SaveFranchiseDocument = gql`
    mutation SaveFranchise($input: SaveFranchiseInput!) {
  saveFranchise(input: $input) {
    franchise {
      id
      name
      motto
      logo
      color
      abbr
      phone
    }
    errors
  }
}
    `;
export type SaveFranchiseMutationFn = Apollo.MutationFunction<SaveFranchiseMutation, SaveFranchiseMutationVariables>;

/**
 * __useSaveFranchiseMutation__
 *
 * To run a mutation, you first call `useSaveFranchiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFranchiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFranchiseMutation, { data, loading, error }] = useSaveFranchiseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFranchiseMutation(baseOptions?: Apollo.MutationHookOptions<SaveFranchiseMutation, SaveFranchiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFranchiseMutation, SaveFranchiseMutationVariables>(SaveFranchiseDocument, options);
      }
export type SaveFranchiseMutationHookResult = ReturnType<typeof useSaveFranchiseMutation>;
export type SaveFranchiseMutationResult = Apollo.MutationResult<SaveFranchiseMutation>;
export type SaveFranchiseMutationOptions = Apollo.BaseMutationOptions<SaveFranchiseMutation, SaveFranchiseMutationVariables>;
export const CreateTransactionAssetDocument = gql`
    mutation CreateTransactionAsset($input: CreateTransactionAssetInput!) {
  createTransactionAsset(input: $input) {
    transaction {
      ...FullTransactionFields
    }
    errors
  }
}
    ${FullTransactionFieldsFragmentDoc}`;
export type CreateTransactionAssetMutationFn = Apollo.MutationFunction<CreateTransactionAssetMutation, CreateTransactionAssetMutationVariables>;

/**
 * __useCreateTransactionAssetMutation__
 *
 * To run a mutation, you first call `useCreateTransactionAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionAssetMutation, { data, loading, error }] = useCreateTransactionAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransactionAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionAssetMutation, CreateTransactionAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionAssetMutation, CreateTransactionAssetMutationVariables>(CreateTransactionAssetDocument, options);
      }
export type CreateTransactionAssetMutationHookResult = ReturnType<typeof useCreateTransactionAssetMutation>;
export type CreateTransactionAssetMutationResult = Apollo.MutationResult<CreateTransactionAssetMutation>;
export type CreateTransactionAssetMutationOptions = Apollo.BaseMutationOptions<CreateTransactionAssetMutation, CreateTransactionAssetMutationVariables>;
export const DeleteTransactionAssetDocument = gql`
    mutation DeleteTransactionAsset($input: DeleteTransactionAssetInput!) {
  deleteTransactionAsset(input: $input) {
    transaction {
      ...FullTransactionFields
    }
    errors
  }
}
    ${FullTransactionFieldsFragmentDoc}`;
export type DeleteTransactionAssetMutationFn = Apollo.MutationFunction<DeleteTransactionAssetMutation, DeleteTransactionAssetMutationVariables>;

/**
 * __useDeleteTransactionAssetMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionAssetMutation, { data, loading, error }] = useDeleteTransactionAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTransactionAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionAssetMutation, DeleteTransactionAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionAssetMutation, DeleteTransactionAssetMutationVariables>(DeleteTransactionAssetDocument, options);
      }
export type DeleteTransactionAssetMutationHookResult = ReturnType<typeof useDeleteTransactionAssetMutation>;
export type DeleteTransactionAssetMutationResult = Apollo.MutationResult<DeleteTransactionAssetMutation>;
export type DeleteTransactionAssetMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionAssetMutation, DeleteTransactionAssetMutationVariables>;
export const NominatePlayerDocument = gql`
    mutation NominatePlayer($playerId: ID!, $amount: Int) {
  nominatePlayer(input: {playerId: $playerId, amount: $amount}) {
    auctionItem {
      ...AuctionItemFields
    }
    errors
  }
}
    ${AuctionItemFieldsFragmentDoc}`;
export type NominatePlayerMutationFn = Apollo.MutationFunction<NominatePlayerMutation, NominatePlayerMutationVariables>;

/**
 * __useNominatePlayerMutation__
 *
 * To run a mutation, you first call `useNominatePlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNominatePlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nominatePlayerMutation, { data, loading, error }] = useNominatePlayerMutation({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useNominatePlayerMutation(baseOptions?: Apollo.MutationHookOptions<NominatePlayerMutation, NominatePlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NominatePlayerMutation, NominatePlayerMutationVariables>(NominatePlayerDocument, options);
      }
export type NominatePlayerMutationHookResult = ReturnType<typeof useNominatePlayerMutation>;
export type NominatePlayerMutationResult = Apollo.MutationResult<NominatePlayerMutation>;
export type NominatePlayerMutationOptions = Apollo.BaseMutationOptions<NominatePlayerMutation, NominatePlayerMutationVariables>;
export const CreateBidDocument = gql`
    mutation CreateBid($amount: Int!, $idempotencyKey: String!, $auctionItemId: ID!) {
  createBid(
    input: {amount: $amount, idempotencyKey: $idempotencyKey, auctionItemId: $auctionItemId}
  ) {
    auctionItem {
      ...AuctionItemFields
    }
    errors
  }
}
    ${AuctionItemFieldsFragmentDoc}`;
export type CreateBidMutationFn = Apollo.MutationFunction<CreateBidMutation, CreateBidMutationVariables>;

/**
 * __useCreateBidMutation__
 *
 * To run a mutation, you first call `useCreateBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBidMutation, { data, loading, error }] = useCreateBidMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *      idempotencyKey: // value for 'idempotencyKey'
 *      auctionItemId: // value for 'auctionItemId'
 *   },
 * });
 */
export function useCreateBidMutation(baseOptions?: Apollo.MutationHookOptions<CreateBidMutation, CreateBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBidMutation, CreateBidMutationVariables>(CreateBidDocument, options);
      }
export type CreateBidMutationHookResult = ReturnType<typeof useCreateBidMutation>;
export type CreateBidMutationResult = Apollo.MutationResult<CreateBidMutation>;
export type CreateBidMutationOptions = Apollo.BaseMutationOptions<CreateBidMutation, CreateBidMutationVariables>;
export const CancelAuctionItemDocument = gql`
    mutation CancelAuctionItem($auctionItemId: ID!) {
  cancelAuctionItem(input: {auctionItemId: $auctionItemId}) {
    auctionItem {
      ...AuctionItemFields
    }
    errors
  }
}
    ${AuctionItemFieldsFragmentDoc}`;
export type CancelAuctionItemMutationFn = Apollo.MutationFunction<CancelAuctionItemMutation, CancelAuctionItemMutationVariables>;

/**
 * __useCancelAuctionItemMutation__
 *
 * To run a mutation, you first call `useCancelAuctionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAuctionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAuctionItemMutation, { data, loading, error }] = useCancelAuctionItemMutation({
 *   variables: {
 *      auctionItemId: // value for 'auctionItemId'
 *   },
 * });
 */
export function useCancelAuctionItemMutation(baseOptions?: Apollo.MutationHookOptions<CancelAuctionItemMutation, CancelAuctionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAuctionItemMutation, CancelAuctionItemMutationVariables>(CancelAuctionItemDocument, options);
      }
export type CancelAuctionItemMutationHookResult = ReturnType<typeof useCancelAuctionItemMutation>;
export type CancelAuctionItemMutationResult = Apollo.MutationResult<CancelAuctionItemMutation>;
export type CancelAuctionItemMutationOptions = Apollo.BaseMutationOptions<CancelAuctionItemMutation, CancelAuctionItemMutationVariables>;
export const StartCountdownDocument = gql`
    mutation StartCountdown($auctionItemId: ID!) {
  startCountdown(input: {auctionItemId: $auctionItemId}) {
    success
    errors
  }
}
    `;
export type StartCountdownMutationFn = Apollo.MutationFunction<StartCountdownMutation, StartCountdownMutationVariables>;

/**
 * __useStartCountdownMutation__
 *
 * To run a mutation, you first call `useStartCountdownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCountdownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCountdownMutation, { data, loading, error }] = useStartCountdownMutation({
 *   variables: {
 *      auctionItemId: // value for 'auctionItemId'
 *   },
 * });
 */
export function useStartCountdownMutation(baseOptions?: Apollo.MutationHookOptions<StartCountdownMutation, StartCountdownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCountdownMutation, StartCountdownMutationVariables>(StartCountdownDocument, options);
      }
export type StartCountdownMutationHookResult = ReturnType<typeof useStartCountdownMutation>;
export type StartCountdownMutationResult = Apollo.MutationResult<StartCountdownMutation>;
export type StartCountdownMutationOptions = Apollo.BaseMutationOptions<StartCountdownMutation, StartCountdownMutationVariables>;
export const PauseCountdownDocument = gql`
    mutation PauseCountdown($auctionItemId: ID!) {
  pauseCountdown(input: {auctionItemId: $auctionItemId}) {
    success
    errors
  }
}
    `;
export type PauseCountdownMutationFn = Apollo.MutationFunction<PauseCountdownMutation, PauseCountdownMutationVariables>;

/**
 * __usePauseCountdownMutation__
 *
 * To run a mutation, you first call `usePauseCountdownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseCountdownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseCountdownMutation, { data, loading, error }] = usePauseCountdownMutation({
 *   variables: {
 *      auctionItemId: // value for 'auctionItemId'
 *   },
 * });
 */
export function usePauseCountdownMutation(baseOptions?: Apollo.MutationHookOptions<PauseCountdownMutation, PauseCountdownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseCountdownMutation, PauseCountdownMutationVariables>(PauseCountdownDocument, options);
      }
export type PauseCountdownMutationHookResult = ReturnType<typeof usePauseCountdownMutation>;
export type PauseCountdownMutationResult = Apollo.MutationResult<PauseCountdownMutation>;
export type PauseCountdownMutationOptions = Apollo.BaseMutationOptions<PauseCountdownMutation, PauseCountdownMutationVariables>;
export const SendAuctionReactionDocument = gql`
    mutation SendAuctionReaction($auctionId: ID!, $emoji: String!) {
  sendAuctionReaction(input: {auctionId: $auctionId, emoji: $emoji}) {
    success
  }
}
    `;
export type SendAuctionReactionMutationFn = Apollo.MutationFunction<SendAuctionReactionMutation, SendAuctionReactionMutationVariables>;

/**
 * __useSendAuctionReactionMutation__
 *
 * To run a mutation, you first call `useSendAuctionReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAuctionReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAuctionReactionMutation, { data, loading, error }] = useSendAuctionReactionMutation({
 *   variables: {
 *      auctionId: // value for 'auctionId'
 *      emoji: // value for 'emoji'
 *   },
 * });
 */
export function useSendAuctionReactionMutation(baseOptions?: Apollo.MutationHookOptions<SendAuctionReactionMutation, SendAuctionReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAuctionReactionMutation, SendAuctionReactionMutationVariables>(SendAuctionReactionDocument, options);
      }
export type SendAuctionReactionMutationHookResult = ReturnType<typeof useSendAuctionReactionMutation>;
export type SendAuctionReactionMutationResult = Apollo.MutationResult<SendAuctionReactionMutation>;
export type SendAuctionReactionMutationOptions = Apollo.BaseMutationOptions<SendAuctionReactionMutation, SendAuctionReactionMutationVariables>;